import { cloneDeep } from 'lodash'

import { BILLING_ROUTES } from '@/routes/billing-routes'
import { ROUTE_NAMES, ROUTE_PATHS } from '@/routes/route-helpers'

import MCPSettings from '@/views/workspaces/settings/integrations/pages/MCPSettings'

// import BrandingSettings from '@/views/workspaces/settings/branding-settings'

export const WEB_APP_SETTINGS_ROUTES = [
  cloneDeep(BILLING_ROUTES),
  {
    path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_INTEGRATIONS_MCP_SETTINGS}`,
    name: ROUTE_NAMES.SETTINGS_INTEGRATIONS_MCP_SETTINGS,
    component: MCPSettings
  }
  // {
  //   path: ROUTE_PATHS.SETTINGS_BRANDING,
  //   name: ROUTE_NAMES.SETTINGS_BRANDING,
  //   component: BrandingSettings
  // }
]
